import ChangeService from '../../services/ChangeService.js'

export const namespaced = true

export const state = {
  changes: [],
  change: {}
}

export const mutations = {
  ADD_CHANGE(state, change) {
    state.changes.push(change)
  },
  SET_CHANGES(state, changes) {
    state.changes = changes
  },
  SET_CHANGE(state, change) {
    state.change = change
  },
  UPDATE_CHANGE(state, change) {
    state.changes = [
      ...state.changes.filter(c => c.changeID !== change.changeID),
      change
    ]
  },
  DELETE_CHANGE(state, id) {
    state.changes = [
      ...state.changes.filter(c => c.changeID !== id)
    ]
  }
}

export const actions = {
  save({ commit }, change) {
    if (change.changeID) {
      return ChangeService.put(change).then(res => {
        const c = res.data
        commit('UPDATE_CHANGE', c)
        commit('SET_CHANGE', c)
      })
    } else {
      return ChangeService.post(change).then(res => {
        const c = res.data
        commit('ADD_CHANGE', c)
        commit('SET_CHANGE', c)
      })
    }
  },
  delete({ commit }, id) {
    return ChangeService.delete(id).then(() => {
      commit('DELETE_CHANGE', id)
    })
  },
  getBySubmission({ commit }, id) {
    return ChangeService.getBySubmission(id).then(res => {
      commit('SET_CHANGES', res.data)
    })
  },
  set({ commit }, id) {
    return new Promise((resolve, reject) => {
      const change = state.changes.find(c => c.changeID == id)
      if (!change) return reject()
      commit('SET_CHANGE', change)
      resolve(change)
    })
  },
  clearChange({ commit }) {
    return new Promise(resolve => {
      commit('SET_CHANGE', {})
      resolve()
    })
  },
  clear({ commit }) {
    return new Promise(resolve => {
      commit('SET_CHANGE', {})
      commit('SET_CHANGES', [])
      resolve()
    })
  },
  setChanges({ commit }, changes) {
    return new Promise(resolve => {
      commit('SET_CHANGES', changes)
      resolve()
    })
  }
}

export const getters = {
  changeById: state => id => state.changes.find(c => c.changeID == id)
}